import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Header from "../components/Header";
import BottomNav from "../components/BottomNav";
import { getMyDuels } from "../lib/api";
import { useAuth } from "../contexts/AuthContext";
import { Swords, Trophy, Plus, ChevronRight } from "lucide-react";

export default function MyDuels() {
  const { user } = useAuth();
  const [duels, setDuels] = useState(null);

  useEffect(() => { getMyDuels().then(setDuels).catch(() => setDuels([])); }, []);

  return (
    <div className="min-h-screen pb-safe" data-testid="my-duels-page">
      <Header title="My Duels" />
      <div className="max-w-xl mx-auto px-4 pt-4 space-y-4">
        <Link
          to="/duel/new"
          data-testid="my-duels-create-btn"
          className="block w-full text-center py-3.5 rounded-full font-bold text-black"
          style={{ background: "linear-gradient(90deg,#FF0055,#B026FF)", boxShadow: "0 0 22px rgba(255,0,85,0.35)" }}
        >
          <Plus className="w-4 h-4 inline -mt-0.5" /> Start a New Duel
        </Link>

        {duels === null && <p className="text-white/60 text-sm">Loading…</p>}
        {duels?.length === 0 && (
          <div className="glass rounded-2xl p-8 text-center">
            <Swords className="w-8 h-8 mx-auto text-[#FF0055]" />
            <p className="font-display font-bold mt-2">No duels yet</p>
            <p className="text-sm text-white/60 mt-1">Challenge a friend and earn +75 XP just for starting.</p>
          </div>
        )}

        {duels && duels.length > 0 && (
          <div className="space-y-2">
            {duels.map((d) => {
              const youCreator = user?.user_id === d.creator_id;
              const iWon = d.status === "done" && d.winner_id === user?.user_id;
              const iLost = d.status === "done" && d.winner_id && d.winner_id !== user?.user_id;
              const opp = youCreator ? (d.opponent_name || "Waiting…") : d.creator_name;
              return (
                <Link key={d.duel_id} to={`/duel/${d.invite_code}`} className="block glass rounded-2xl p-4 card-hover" data-testid={`my-duel-row-${d.invite_code}`}>
                  <div className="flex items-center gap-3">
                    <div className="w-10 h-10 rounded-xl grid place-items-center shrink-0" style={{ background: "linear-gradient(135deg,#FF005555,#B026FF55)" }}>
                      <Swords className="w-5 h-5" />
                    </div>
                    <div className="flex-1 min-w-0">
                      <p className="font-display font-semibold truncate">vs {opp}</p>
                      <p className="text-[11px] text-white/50 font-mono-brand">{d.invite_code}</p>
                    </div>
                    <div className="text-right">
                      {d.status === "open" && (
                        <span className="chip" style={{ background: "#FFD60022", color: "#FFD600", border: "1px solid #FFD60055" }}>● Open</span>
                      )}
                      {iWon && <span className="chip" style={{ background: "#00FF6622", color: "#00FF66", border: "1px solid #00FF6655" }}><Trophy className="w-3 h-3" /> Won</span>}
                      {iLost && <span className="chip" style={{ background: "#FF005522", color: "#FF0055", border: "1px solid #FF005555" }}>Lost</span>}
                    </div>
                    <ChevronRight className="w-4 h-4 text-white/40" />
                  </div>
                  <div className="mt-2 flex items-center gap-3 text-[11px] text-white/60">
                    <span>Creator: <b className="text-white/80 font-mono-brand">{d.creator_lineup?.points?.toFixed?.(0) || 0}</b></span>
                    <span>Opponent: <b className="text-white/80 font-mono-brand">{d.opponent_lineup?.points?.toFixed?.(0) || "—"}</b></span>
                  </div>
                </Link>
              );
            })}
          </div>
        )}

        <div className="h-10" />
      </div>
      <BottomNav />
    </div>
  );
}
